import { useFormik } from "formik"
import React, { useEffect } from "react"
import * as Yup from "yup"
import DatePicker from "react-datepicker"
import Select from "react-select"
import { Col, Input, Label, Row, Form, FormFeedback } from "reactstrap"
import TableContainer from "components/Common/TableContainer"
import moment from "moment"
import { onUpdateTeams, onUpdateTeamsNoApproved } from "store/createTeam/action"
import { useDispatch } from "react-redux"
import { customStylesSelect } from "common/data/settings"
const ManageTeamForms = ({
  teamList,
  filtersubCategory,
  setfiltersubCategory,
  selectedData,
  handleCancel,
  setselectedData,
  companySetting,
  isDisable,
  setModal,
}) => {
  const dispatch = useDispatch()
  // Handle End Date
  const endDateChange = (date, selectedvalue) => {
    var tempData = selectedData?.teamMembers.map(item => {
      if (item?.userId === selectedvalue.userId) {
        return { ...item, endDate: moment(new Date(date)).format("YYYY-MM-DD") }
      }
      return item
    })
    setselectedData({ ...selectedData, teamMembers: tempData })
  }

  // Handle Start Date
  const ModalstartDate = (date, selectedvalue) => {
    var tempData = selectedData?.teamMembers.map(item => {
      if (item?.userId === selectedvalue.userId) {
        return {
          ...item,
          startDate: moment(date).format("YYYY-MM-DDTHH:mm:ss"),
        }
      }
      return item
    })
    setselectedData({ ...selectedData, teamMembers: tempData })
  }

  // Handle Active Checkbox
  const activechange = (value, selectedvalue) => {
    var tempData = selectedData.teamMembers.map((item, index) => {
      if (item?.userId === selectedvalue.userId) {

        return { ...item, active: value?.target?.checked }
      }
      return item
    })
    setselectedData({ ...selectedData, teamMembers: tempData })
  }

  const columns = React.useMemo(() => {
    const result = [
      {
        Header: "UserName",
        accessor: "username",
        disableFilters: true,
        filterable: true,
      },

      {
        Header: "Start Date",
        accessor: "startDate",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => (
          <div>
            <DatePicker
              wrapperClassName="datePicker"
              dateFormat="yyyy-MM-dd"
              selected={new Date(cellProps?.row?.original?.startDate)}
              onChange={value =>
                ModalstartDate(value, cellProps?.row?.original)
              }
              className="form-control mb-0 date-icon-back"
              placeholderText="Select date"
              // maxDate={new Date()}
            />
          </div>
        ),
      },
      {
        Header: "End Date",
        accessor: "endDate",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => (
          <div>
            <DatePicker
              wrapperClassName="datePicker"
              dateFormat="yyyy-MM-dd"
              selected={
                cellProps?.row?.original?.endDate &&
                new Date(cellProps?.row?.original?.endDate)
              }
              onChange={value => endDateChange(value, cellProps?.row?.original)}
              className="form-control mb-0 date-icon-back"
              placeholderText="Select date"
              minDate={new Date(cellProps?.row?.original?.startDate)}
            />
          </div>
        ),
      },

      {
        Header: "Active",
        accessor: "active",
        disableFilters: true,
        minWidth: 50,
        width: 50,
        Cell: cellProps => (
          <div style={{ textAlign: "center" }}>
            <Input
              className="form-check-input"
              type="checkbox"
              id="active"
              defaultChecked={
                cellProps.row.original.active == true ? true : false
              }
              onChange={value => activechange(value, cellProps?.row?.original)}
            />
          </div>
        ),
      },
    ]
    return result
  }, [selectedData])

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      id: selectedData.id,
      maincategory: selectedData.categoryid || "",
      subcategory: selectedData.subcategoryid || "",
      // reportTo: mergeDatas?.[0]?.reportToId || "",
      reportTo:
        selectedData?.teamMembers?.map(item => {
          return {
            ...item,
            label: item.reportToName,
            value: item.reportToId,
          }
        }) || "",
      supervisorby:
        selectedData?.teamMembers?.map(item => {
          return {
            ...item,
            label: item.supervisorname,
            value: item.supervisorid,
          }
        }) || "",
      // supervisorby: selectedData.supervisorid || "",
      user:
        selectedData?.teamMembers?.map(item => {
          return {
            ...item,
            label: item.username,
            value: item.userId,
          }
        }) || "",
      startdate: moment(new Date()).format("YYYY-MM-DD") || new Date(),
      enddate: moment(new Date()).format("YYYY-MM-DD") || new Date(),
    },
    validationSchema: Yup.object().shape({}),
    onSubmit: values => {
      const mergeUserDatas = values.user?.map(el => ({
        userid: el.userid,
        startDate: el.startDate,
        endDate: el.endDate ? moment(el.endDate).format("YYYY-MM-DDTHH:mm:ss") : null,
        teamdurationid: el.durationList?.[0]?.id,
        status: el?.active == null || el?.active == false ? false : true,
      }))
      const mergeUserDatasID = values.user?.map(el => ({
        userid: el.userId,
      }))
      const mergeUserDatasIDnoapprove = values.user?.map(el => ({
        userid: el.userId,
        startDate: el?.startDate,
        endDate: el.endDate ? moment(el.endDate).format("YYYY-MM-DDTHH:mm:ss") : null,
        teamdurationid: el.durationList?.[0]?.id,
        status: el?.active == null || el?.active == false ? false : true,
      }))

      const userid = JSON.parse(localStorage.getItem("authUser") || "{}")?.data
        ?.id
      const updateTeam = {
        categoryId: values.maincategory,
        subCategoryId: values.subcategory,
        reportTo: values.reportTo.value
          ? values.reportTo.value
          : values.reportTo[0].reportToId,
        supervisorId: values.supervisorby.value
          ? values.supervisorby.value
          : values.supervisorby[0].supervisorid,
        teammembers: mergeUserDatasID,
        id: 0,
        updatedBy: userid,
        previousSupervisorId: 0,
        previousReportingTo: 0,
        teamupdatemembers: mergeUserDatas,
        teamuserId: 0,
        teamsupervisorId: 0,
        teamdurationId: 0,
      }

      // no approve team
      const updateTeamnoapprove = {
        categoryId: values.maincategory,
        subCategoryId: values.subcategory,
        reportTo: values.reportTo.value
          ? values.reportTo.value
          : values.reportTo[0].reportToId,
        supervisorId: values.supervisorby.value
          ? values.supervisorby.value
          : values.supervisorby[0].supervisorid,
        teammembers: mergeUserDatasIDnoapprove,
        id: 0,
        supervisorUserId: values.supervisorby.value
          ? values.supervisorby.value
          : values.supervisorby[0].supervisorid,
      }

      // return false
      if (selectedData.approved == false) {
        // return false
        dispatch(onUpdateTeamsNoApproved(updateTeamnoapprove, handleResponse))
      } else {
        dispatch(onUpdateTeams(updateTeam, handleResponse))  
      }
    },
  })

  const handleResponse = status => {
    if (status === "SUCCESS") {
      setModal(false)
    }
  }

  //handle sub-category
  useEffect(() => {
    const filteredData = teamList?.subCategoryLookup?.filter(
      el => el?.categoryId == validation.values.maincategory
    )
    setfiltersubCategory(filteredData)
  }, [validation.values.maincategory])
  return (
    <Form
      onSubmit={e => {
        e.preventDefault()
        validation.handleSubmit()
        return false
      }}
    >
      <Col md="12" className="mt-2 mb-2">
        <Row form>
          <Col md="4">
            <div>
              <Label htmlFor="formrow-state-Input">
                {companySetting.MainCategory}
              </Label>
              <Input
                id="maincategory"
                type="select"
                name="maincategory"
                disabled
                value={validation.values.maincategory || ""}
                onBlur={validation.handleBlur}
                onChange={validation.handleChange}
                invalid={
                  validation.touched.maincategory &&
                  validation.errors.maincategory
                    ? true
                    : false
                }
              >
                <option key={`optionVal_empty`} value="">
                  Please Select {companySetting.MainCategory}
                </option>
                {(teamList?.categoryLookup || [])?.map((option, i) => (
                  <option key={`optionVal_${i}`} value={option?.id}>
                    {option?.name}
                  </option>
                ))}
              </Input>

              {validation.touched.maincategory &&
              validation.errors.maincategory ? (
                <FormFeedback type="invalid">
                  {validation.errors.maincategory}
                </FormFeedback>
              ) : null}
            </div>
          </Col>
          <Col md="4">
            <div>
              <Label htmlFor="formrow-state-Input">
                {companySetting.SubCategory}
              </Label>
              <Input
                id="subcategory"
                type="select"
                name="subcategory"
                disabled
                value={validation.values.subcategory || ""}
                onBlur={validation.handleBlur}
                onChange={validation.handleChange}
                invalid={
                  validation.touched.subcategory &&
                  validation.errors.subcategory
                    ? true
                    : false
                }
              >
                <option key={`optionVal_empty`} value="">
                  Please Select {companySetting.SubCategory}
                </option>
                {(filtersubCategory || [])?.map((option, i) => (
                  <option key={`optionVal_${i}`} value={option?.id}>
                    {option?.name}
                  </option>
                ))}
              </Input>

              {validation.touched.subcategory &&
              validation.errors.subcategory ? (
                <FormFeedback type="invalid">
                  {validation.errors.subcategory}
                </FormFeedback>
              ) : null}
            </div>
          </Col>
          <Col md="4">
            <div>
              <Label htmlFor="formrow-state-Input">Report To</Label>
              <Select
                id="reportTo"
                name="reportTo"
                defaultValue={validation.values.reportTo}
                onBlur={validation.handleBlur}
                onChange={value => {
                  validation.setFieldValue("reportTo", value)
                }}
                options={teamList?.reportToLookup?.map(el => ({
                  ...el,
                  label: el.userName,
                  value: el.userId,
                }))}
                classNamePrefix="select2-selection"
                styles={customStylesSelect}
              />
              {validation.touched.reportTo && validation.errors.reportTo ? (
                <FormFeedback type="invalid">
                  {validation.errors.reportTo}
                </FormFeedback>
              ) : null}
            </div>
          </Col>
        </Row>
        <Row>
          <Col md="4">
            <div className="mt-2">
              <Label htmlFor="formrow-state-Input">User</Label>
              <Select
                isMulti
                id="user"
                name="user"
                defaultValue={validation.values.user}
                onBlur={validation.handleBlur}
                onChange={value => {
                  validation.setFieldValue("user", value)
                }}
                options={teamList?.teamMemberLookup?.map(el => ({
                  ...el,
                  label: el.userName,
                  value: el.userId,
                }))}
                classNamePrefix="select2-selection"
                styles={customStylesSelect}
              />
            </div>
          </Col>
          <Col md="4">
            <div className="mt-2">
              <Label htmlFor="formrow-state-Input">Start Date</Label>
              <DatePicker
                wrapperClassName="datePicker"
                dateFormat="yyyy-MM-dd"
                selected={new Date(validation.values.startdate)}
                onChange={value => validation.setFieldValue("startdate", value)}
                className="form-control mb-0 date-icon-back"
                placeholderText="Select date"
                // maxDate={new Date()}
              />
            </div>
          </Col>
          <Col md="4">
            <div className="mt-2">
              <Label htmlFor="formrow-state-Input">Supervisor by</Label>

              <Select
                id="supervisorby"
                name="supervisorby"
                isDisabled={isDisable}
                defaultValue={validation.values.supervisorby}
                onBlur={validation.handleBlur}
                onChange={value => {
                  validation.setFieldValue("supervisorby", value)
                }}
                options={teamList?.teamSupervisorLookup?.map(el => ({
                  ...el,
                  label: el.userName,
                  value: el.userId,
                }))}
                styles={customStylesSelect}
                classNamePrefix="select2-selection"
              />
              {validation.touched.supervisorby &&
              validation.errors.supervisorby ? (
                <FormFeedback type="invalid">
                  {validation.errors.supervisorby}
                </FormFeedback>
              ) : null}
            </div>
          </Col>
        </Row>
        <TableContainer
          data={selectedData?.teamMembers || []}
          columns={columns}
          customPageSize={40}
          hidepagination={true}
        />
      </Col>

      <div className="text-end">
        <button type="submit" className="btn btn-primary save-customer me-2">
          Save
        </button>
        <button
          type="button"
          color="primary"
          className="btn btn-secondary"
          onClick={handleCancel}
        >
          Cancel
        </button>
      </div>
    </Form>
  )
}

export default ManageTeamForms
